/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define([], function() {
    'use strict';
    /*this mapping is used to map category_codes => filename
        https://developer.tomtom.com/online-search/online-search-documentation/supported-category-codes
        keep in mind that files in the filesystem are named like that: RESTAURANT.colors-black-white.svg
        colors-black-white is used during compilation to generate white and black icons
        icons are converted to css and included in map.css
    */
    var availableIcons = {
        fallback: 'flag',
        ACCESS_GATEWAY: 'ic_map_poi_110',
        ADMINISTRATIVE_DIVISION: 'ic_map_poi_133',
        ADVENTURE_SPORTS_VENUE: 'ic_map_poi_122',
        AGRICULTURE: 'ic_map_poi_107',
        AIRPORT: 'ic_map_poi_007',
        AMUSEMENT_PARK: 'ic_map_poi_051',
        AUTOMOTIVE_DEALER: 'ic_map_poi_008',
        BANK: 'ic_map_poi_077',
        BEACH: 'ic_map_poi_043',
        BUILDING_POINT: 'ic_map_poi_132',
        BUSINESS_PARK: 'ic_map_poi_102',
        CAFE_PUB: 'ic_map_poi_120',
        CAMPING_GROUND: 'ic_map_poi_058',
        CAR_WASH: 'ic_map_poi_067',
        CASH_DISPENSER: 'ic_map_poi_042',
        CASINO: 'ic_map_poi_009',
        CINEMA: 'ic_map_poi_011',
        CITY_CENTER: 'ic_map_poi_012',
        CLUB_ASSOCIATION: 'ic_map_poi_131',
        COLLEGE_UNIVERSITY: 'ic_map_poi_041',
        COMMERCIAL_BUILDING: 'ic_map_poi_098',
        COMMUNITY_CENTER: 'ic_map_poi_081',
        COMPANY: 'ic_map_poi_013',
        COURTHOUSE: 'ic_map_poi_015',
        CULTURAL_CENTER: 'ic_map_poi_016',
        DENTIST: 'ic_map_poi_048',
        DEPARTMENT_STORE: 'ic_map_poi_104',
        DOCTOR: 'ic_map_poi_047',
        ELECTRIC_VEHICLE_STATION: 'ic_map_poi_073',
        EMBASSY: 'ic_map_poi_040',
        EMERGENCY_MEDICAL_SERVICE: 'ic_map_poi_115',
        ENTERTAINMENT: 'ic_map_poi_035',
        EXCHANGE: 'ic_map_poi_096',
        EXHIBITION_CONVENTION_CENTER: 'ic_map_poi_017',
        FERRY_TERMINAL: 'ic_map_poi_018',
        FIRE_STATION_BRIGADE: 'ic_map_poi_068',
        FRONTIER_CROSSING: 'ic_map_poi_019',
        FUEL_FACILITIES: 'ic_map_poi_004',
        GEOGRAPHIC_FEATURE: 'ic_map_poi_127',
        GOLF_COURSE: 'ic_map_poi_020',
        GOVERNMENT_OFFICE: 'ic_map_poi_000',
        HEALTH_CARE_SERVICE: 'ic_map_poi_116',
        HELIPAD_HELICOPTER_LANDING: 'ic_map_poi_123',
        HOLIDAY_RENTAL: 'ic_map_poi_130',
        HOSPITAL_POLYCLINIC: 'ic_map_poi_021',
        HOTEL_MOTEL: 'ic_map_poi_022',
        ICE_SKATING_RINK: 'ic_map_poi_044',
        IMPORTANT_TOURIST_ATTRACTION: 'ic_map_poi_023',
        INDUSTRIAL_BUILDING: 'ic_map_poi_095',
        LEISURE_CENTER: 'ic_map_poi_061',
        LIBRARY: 'ic_map_poi_052',
        MANUFACTURING_FACILITY: 'ic_map_poi_099',
        MARINA: 'ic_map_poi_062',
        MARKET: 'ic_map_poi_118',
        MEDIA_FACILITY: 'ic_map_poi_101',
        MILITARY_INSTALLATION: 'ic_map_poi_106',
        MOTORING_ORGANIZATION_OFFICE: 'ic_map_poi_076',
        MOUNTAIN_PASS: 'ic_map_poi_024',
        MUSEUM: 'ic_map_poi_025',
        NATIVE_RESERVATION: 'ic_map_poi_125',
        NIGHTLIFE: 'ic_map_poi_050',
        NON_GOVERNMENTAL_ORGANIZATION: 'ic_map_poi_134',
        OPEN_PARKING_AREA: 'ic_map_poi_002',
        OTHER: 'flag',
        PARKING_GARAGE: 'ic_map_poi_003',
        PARK_RECREATION_AREA: 'ic_map_poi_059',
        PETROL_STATION: 'ic_map_poi_004',
        PHARMACY: 'ic_map_poi_054',
        PLACE_OF_WORSHIP: 'ic_map_poi_027',
        POLICE_STATION: 'ic_map_poi_039',
        PORT_WAREHOUSE_FACILITY: 'ic_map_poi_105',
        POST_OFFICE: 'ic_map_poi_028',
        PRIMARY_RESOURCE_UTILITY: 'ic_map_poi_108',
        PRISON_CORRECTIONAL_FACILITY: 'ic_map_poi_094',
        PUBLIC_AMENITY: 'ic_map_poi_097',
        PUBLIC_TRANSPORT_STOP: 'ic_map_poi_069',
        RAILWAY_STATION: 'ic_map_poi_005',
        RENT_A_CAR_FACILITY: 'ic_map_poi_029',
        RENT_A_CAR_PARKING: 'ic_map_poi_030',
        REPAIR_FACILITY: 'ic_map_poi_053',
        RESEARCH_FACILITY: 'ic_map_poi_100',
        RESIDENTIAL_ACCOMMODATION: 'ic_map_poi_075',
        RESTAURANT: 'ic_map_poi_031',
        RESTAURANT_AREA: 'ic_map_poi_031',
        REST_AREA: 'ic_map_poi_006',
        SCENIC_PANORAMIC_VIEW: 'ic_map_poi_055',
        SCHOOL: 'ic_map_poi_070',
        SHOP: 'ic_map_poi_032',
        SHOPPING_CENTER: 'ic_map_poi_033',
        SPORTS_CENTER: 'ic_map_poi_038',
        STADIUM: 'ic_map_poi_034',
        SWIMMING_POOL: 'ic_map_poi_046',
        TENNIS_COURT: 'ic_map_poi_045',
        THEATER: 'ic_map_poi_035',
        TOURIST_INFORMATION_OFFICE: 'ic_map_poi_023',
        TRAFFIC_LIGHT: 'ic_map_poi_129',
        TRAFFIC_SERVICE_CENTER: 'ic_map_poi_126',
        TRAFFIC_SIGN: 'ic_map_poi_128',
        TRAIL_SYSTEM: 'ic_map_poi_124',
        TRANSPORT_AUTHORITY_VEHICLE_REGISTRATION: 'ic_map_poi_113',
        TRUCK_STOP: 'ic_map_poi_071',
        VETERINARIAN: 'ic_map_poi_049',
        WATER_SPORT: 'ic_map_poi_046',
        WEIGH_STATION: 'ic_map_poi_111',
        WELFARE_ORGANIZATION: 'ic_map_poi_117',
        WINERY: 'ic_map_poi_057',
        ZOOS_ARBORETA_BOTANICAL_GARDEN: 'ic_map_poi_037'
    };

    /*
        This map contains icons which are single color - means they are not in black and white version
     */
    var singleColorIcons = {
        OPEN_PARKING_AREA: '',
        PARKING_GARAGE: '',
        RENT_A_CAR_PARKING: '',
        TRUCK_STOP: ''
    };

    return {
        defaultIcons: availableIcons,
        singleColorIcons: singleColorIcons
    };
});



// WEBPACK FOOTER //
// ./display/layers/defaultIconsMappingProvider.js